import React from 'react';

import { WidgetBaseContainer } from './WidgetBase.styled';

import { DashboardSettings } from '../DashboardSettings/DashboardSettings';

interface Props {
  className?: string;
  variant?: number;
  bgColor?: string;
  hideSettings?: boolean;
}

export const WidgetBase = ({
  children,
  className,
  variant,
  bgColor,
  hideSettings
}: React.PropsWithChildren<Props>) => {
  return (
    <WidgetBaseContainer className={className} $variant={variant} $bgColor={bgColor}>
      <DashboardSettings hideSettings={Boolean(hideSettings)} />
      {children}
    </WidgetBaseContainer>
  );
};
